import React, { useEffect, useState } from "react";

import { useRef } from "react";

function ReleaseTimer({ expiresAt, onExpired }) {
  const [timeLeft, setTimeLeft] = useState("");

  const hasExpired = useRef(false);
  
  useEffect(() => {
    if (!expiresAt) return;
  
    hasExpired.current = false;
  
    const updateTimer = () => {
      const diff = expiresAt - Date.now();
  
      if (diff <= 0) {
        setTimeLeft("00:00");
  
        if (!hasExpired.current) {
          hasExpired.current = true;
          clearInterval(interval);
          onExpired?.();
        }
  
        return;
      }
  
      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
  
      setTimeLeft(
        `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
      );
    };
  
    const interval = setInterval(updateTimer, 1000);
  
    updateTimer();
  
    return () => clearInterval(interval);
  }, [expiresAt]);

  return (
    <span
      className=""
      style={{color: 'red'}}
      // onClick={onRelease}
    >
      Time Left {timeLeft}
    </span>
  );
}

export default React.memo(ReleaseTimer);